import {
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
  Typography,
  Box,
} from "@mui/material";

const cellSx = {
  padding: "10px 12px",
  fontFamily: "Inter-Medium",
  fontSize: "13px",
  color: "#344054",
  borderBottom: "1px solid #EEF0F3",
  fontVariantNumeric: "tabular-nums",
};

const getSuccessStyle = (rate) => {
  if (rate >= 95) return { color: "#027A48", backgroundColor: "#ECFDF3" };
  if (rate >= 80) return { color: "#B54708", backgroundColor: "#FFFAEB" };
  return { color: "#B42318", backgroundColor: "#FEF3F2" };
};

export default function VendorWiseCostingTable({ data, loading, error }) {

  const rowHeight = 45;
  const headerHeight = 45; 
  const maxVisibleRows = 6; 
const shouldScroll = data.length > maxVisibleRows;
  const calculatedHeight = shouldScroll
    ? headerHeight + (maxVisibleRows * rowHeight)
    : headerHeight + (data.length * rowHeight);

  return (
    <Box
      sx={{
        backgroundColor: "#fff",
        borderRadius: "12px",
        border: "1px solid #e0e0e0",
        boxShadow: "0 4px 12px rgba(0,0,0,0.06)",
        padding: 1,
        height: "100%",
        display: "flex",
        flexDirection: "column",
        overflow: "hidden",
      }}
    >
      <Typography
        variant="h5"
        mt={2}
        mb={1}
        sx={{
          display: "flex",
          justifyContent: "center",
          flexShrink: 0,
        }}
      >
        <p style={{ fontFamily: 'Inter-Medium', color: '#667085', fontSize: '25px' }}>Vendor API Cost Analytics</p>
      </Typography>

      {loading && (
        <Typography align="center" color="text.secondary" py={4}>
          Loading table…
        </Typography>
      )}

      {!loading && error && (
        <Typography align="center" color="error" py={4}>
          {error}
        </Typography>
      )}

      {!loading && !error && (
        <TableContainer
          component={Paper}
          elevation={0}
          sx={{
            flexGrow: 1,
            borderRadius: "8px",
            border: "1px solid #EAECF0",
            overflow: shouldScroll ? "auto" : "visible",
            maxHeight: shouldScroll
              ? `${calculatedHeight}px`
              : "none", 
            "&::-webkit-scrollbar": {
              display: "none",
            },
            "&::-webkit-scrollbar-track": {
              backgroundColor: "#f1f1f1",
            },
            "&::-webkit-scrollbar-thumb": {
              backgroundColor: "#888",
              borderRadius: "4px",
              "&:hover": {
                backgroundColor: "#555",
              },
            },
          }}
        >
          <Table stickyHeader={shouldScroll} sx={{ tableLayout: "fixed" }}>
            <TableHead>
              <TableRow>
                {[
                  { label: "Vendor", align: "left" },
                  { label: "Success %", align: "center", width: "18%" },
                  { label: "Total Hits", align: "right", width: "16%" },
                  { label: "Total Cost (₹)", align: "right", width: "20%" },
                ].map((head) => (
                  <TableCell
                    key={head.label}
                    align={head.align}
                    sx={{
                      width: head.width,
                      backgroundColor: "#0f5f7f !important",
                      color: "#fff",
                      fontFamily: "Inter-SemiBold",
                      fontSize: "13px",
                      letterSpacing: "0.3px",
                      padding: "10px 12px",
                      borderBottom: "none",
                      whiteSpace: "nowrap",
                      ...(shouldScroll && {
                        position: "sticky",
                        top: 0,
                        zIndex: 10,
                      }),
                    }}
                  >
                    {head.label}
                  </TableCell>
                ))}
              </TableRow>
            </TableHead>

            <TableBody>
              {data.map((row, index) => (
                <TableRow
                  key={row.apiId || index}
                  sx={{
                    transition: "background-color 0.2s ease",
                    "&:nth-of-type(odd)": {
                      backgroundColor: "#f5f7f9",
                    },
                    "&:hover": {
                      backgroundColor: "#E8F3F7",
                    },
                    "&:last-child td": {
                      borderBottom: "none",
                    },
                  }}
                >
                  <TableCell sx={{ ...cellSx, whiteSpace: "nowrap", overflow: "hidden", textOverflow: "ellipsis" }}>
                    <span style={{ fontFamily: "Inter-SemiBold", color: "#101828" }}>{row.vendor}</span>
                    <span style={{ color: "#667085" }}> - {row.apiName}</span>
                  </TableCell>
                  {/* <TableCell>{row.apiName}</TableCell> */}
                  <TableCell align="center" sx={cellSx}>
                    <span
                      style={{
                        ...getSuccessStyle(Number(row.successRate)),
                        display: "inline-block",
                        padding: "2px 10px",
                        borderRadius: "999px",
                        fontFamily: "Inter-SemiBold",
                        fontSize: "12px",
                      }}
                    >
                      {row.successRate}%
                    </span>
                  </TableCell>
                  <TableCell align="right" sx={cellSx}>
                    {Number(row.totalHits).toLocaleString("en-IN")}
                  </TableCell>
                  <TableCell align="right" sx={{ ...cellSx, fontFamily: "Inter-SemiBold", color: "#101828" }}>
                    ₹{Number(row.totalCost).toLocaleString("en-IN", { minimumFractionDigits: 2, maximumFractionDigits: 2 })}
                  </TableCell>
                </TableRow>
              ))}

              {data.length === 0 && (
                <TableRow>
                  <TableCell colSpan={5} align="center">
                    No data available
                  </TableCell>
                </TableRow>
              )}
            </TableBody>
          </Table>
        </TableContainer>
      )}
    </Box>
  );
}